// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"374":"a3e423cd","536":"2b070f21","660":"a3e423cd","926":"a3e423cd"}[chunkId] + ".chunk.css");